/**
 * REPO_BEAT overlay — fade-to-black ending for Act 1.
 * Spec: BLUEPRINT.md § Scene 3 / REPO_BEAT.
 */

const FADE_MS = 600;

export async function runRepoBeat(): Promise<void> {
  const overlay = document.createElement("div");
  Object.assign(overlay.style, {
    position: "fixed",
    inset: "0",
    background: "#000",
    zIndex: "9999",
    opacity: "0",
    transition: `opacity ${FADE_MS}ms`,
  } as CSSStyleDeclaration);
  document.body.append(overlay);
  requestAnimationFrame(() => { overlay.style.opacity = "1"; });
  await new Promise((r) => setTimeout(r, FADE_MS + 50));
  // Overlay stays mounted — Act 2 takes the surface from here.
}
